import { Button, Intent, Popover} from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";

import { Logo } from "./styled/fragments";
import SystemHealth from "./SystemHealth";
import SystemInfo from "./SystemInfo";

const SystemInfoButtons: React.SFC = () => (
	<React.Fragment>
		<Popover content={<SystemInfo />} usePortal={false}>
			<Logo />
		</Popover>

		<Popover content={<SystemHealth />} usePortal={false}>
			<Button icon={IconNames.PULSE} minimal={true} intent={Intent.NONE} />
		</Popover>
	</React.Fragment>
);

export default SystemInfoButtons;



// WEBPACK FOOTER //
// ./src/core/components/editor/SystemInfoButtons.tsx